import styled from 'styled-components';

import { EditableType } from '../../../containers/Editor/constants';
import { NewStyleColor } from '../../../utils/styles-constants';

interface FrameProps {
	mediaType: EditableType;
	isActive: boolean;
	canDragAndResize: boolean;
	width: number;
	height: number;
	isAccessibleVersion: boolean;
}

interface FrameBorderProps {
	borderWidth: number;
	isActive: boolean;
}

interface FrameLoaderProps {
	borderWidth: number;
}

interface FrameLoaderInnerProps {
	scale: number;
}

const Frame = styled('div')`
	position: relative;
	width: ${({ width }: FrameProps) => `${width}px`};
	height: ${({ height }: FrameProps) => `${height}px`};
	overflow: ${({ isActive }: FrameProps) => isActive ? 'visible' : 'hidden'};
	pointer-events: ${({ isActive, canDragAndResize }: FrameProps) => isActive && canDragAndResize ? 'none' : 'auto'};
	border-radius: inherit;

	[class*="is-rounded"] & {
		border-radius: 50%;
	}

	img, svg {
		position: ${({ isAccessibleVersion }: FrameProps) => isAccessibleVersion ? 'relative' : 'absolute'};
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		max-width: ${({ isAccessibleVersion }: FrameProps) => isAccessibleVersion ? undefined : '100%'};
		max-height: ${({ isAccessibleVersion }: FrameProps) => isAccessibleVersion ? undefined : '100%'};
		width: ${({ mediaType }: FrameProps) => mediaType === EditableType.video ? 'auto' : '100%'};
		height: auto;
		margin: auto;
		pointer-events: auto;
	}

	img {
		${({ mediaType }: FrameProps) => mediaType === EditableType.animation && `
			max-height: none;
			margin: 0;
		`}
	}

	svg {
		width: 50%;
		height: 50%;
		fill: ${NewStyleColor.Grey400};
	}
`;

const FrameBorder = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border: ${({ borderWidth }: FrameBorderProps) => `${borderWidth}px`}
		solid
		${({ isActive }: FrameBorderProps) => isActive ? `${NewStyleColor.Blue100}` : `${NewStyleColor.Grey400}`};
	border-radius: inherit;

	${({ isActive }: FrameBorderProps) => isActive && 'z-index: 1;'}
`;

const FrameLoader = styled('div')`
	position: absolute;
	top: ${({ borderWidth }: FrameLoaderProps) => `${borderWidth}px`};
	bottom: ${({ borderWidth }: FrameLoaderProps) => `${borderWidth}px`};
	left: ${({ borderWidth }: FrameLoaderProps) => `${borderWidth}px`};
	right: ${({ borderWidth }: FrameLoaderProps) => `${borderWidth}px`};
	z-index: 1;
`;

const FrameLoaderInner = styled('div')`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: ${({ scale }: FrameLoaderInnerProps) => `translate(-50%, -50%) scale(${1 / scale})`};
	padding: 5px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Grey800};
	text-align: center;

	span {
		display: block;
	}
`;

const FrameMask = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${NewStyleColor.White};
	opacity: 0.9;
`;

export {
	Frame,
	FrameBorder,
	FrameLoader,
	FrameLoaderInner,
	FrameMask,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/MediaEditor/styles.ts